(() => {
  const header = document.querySelector('[data-wl-header]');
  if (!header) return;

  const onScroll = () => {
    if (window.scrollY > 20) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const searchToggle = header.querySelector('[data-wl-search-toggle]');
  const searchPanel = header.querySelector('[data-wl-search-panel]');
  const menuToggle = header.querySelector('[data-wl-menu-toggle]');

  searchToggle?.addEventListener('click', () => {
    header.classList.toggle('is-search-open');
    header.classList.remove('is-menu-open');
    if (header.classList.contains('is-search-open')) {
      setTimeout(() => searchPanel?.querySelector('input[type="search"]')?.focus(), 120);
    }
  });

  menuToggle?.addEventListener('click', () => {
    header.classList.toggle('is-menu-open');
    header.classList.remove('is-search-open');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      header.classList.remove('is-search-open', 'is-menu-open');
    }
  });
})();
/* ================================
  WARDROBE LAB Product Slider
================================ */
(function () {
  function initWLProductSliders() {
    var sliders = document.querySelectorAll('[data-wl-slider]');

    sliders.forEach(function (slider) {
      if (slider.dataset.wlSliderReady === 'true') return;
      slider.dataset.wlSliderReady = 'true';

      var track = slider.querySelector('.wl-product-slider__track');
      var slides = slider.querySelectorAll('.wl-product-slider__slide');
      var prev = slider.querySelector('[data-wl-prev]');
      var next = slider.querySelector('[data-wl-next]');
      var current = slider.querySelector('[data-wl-current]');
      var total = slider.querySelector('[data-wl-total]');

      if (!track || !slides.length) return;

      if (total) {
        total.textContent = slides.length;
      }

      function getSlideWidth() {
        return track.getBoundingClientRect().width || track.clientWidth;
      }

      function getCurrentIndex() {
        var width = getSlideWidth();
        if (!width) return 0;
        return Math.round(track.scrollLeft / width);
      }

      function updateCounter() {
        if (!current) return;

        var index = getCurrentIndex();
        index = Math.max(0, Math.min(index, slides.length - 1));

        current.textContent = index + 1;
      }

      function goToSlide(index) {
        var width = getSlideWidth();
        if (!width) return;

        var safeIndex = index;

        if (safeIndex < 0) {
          safeIndex = slides.length - 1;
        }

        if (safeIndex > slides.length - 1) {
          safeIndex = 0;
        }

        track.scrollTo({
          left: safeIndex * width,
          behavior: 'smooth'
        });

        setTimeout(updateCounter, 350);
      }

      if (prev) {
        prev.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          goToSlide(getCurrentIndex() - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          goToSlide(getCurrentIndex() + 1);
        });
      }

      var ticking = false;

      track.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            updateCounter();
            ticking = false;
          });

          ticking = true;
        }
      }, { passive: true });

      window.addEventListener('resize', function () {
        updateCounter();
      });

      updateCounter();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWLProductSliders);
  } else {
    initWLProductSliders();
  }

  window.addEventListener('load', initWLProductSliders);

  document.addEventListener('shopify:section:load', initWLProductSliders);
})();
